import React, {useEffect, useRef} from 'react';

const getTimeRemaining = (time: string) => {
  const parse = (date: Date) => {
    return Date.parse(date.toString());
  };
  const total = Date.parse(time) - parse(new Date());
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  if (total < 0) {
    return null;
  } else {
    return {total, days, hours, minutes, seconds};
  }
};

interface Props {
  expire_at: string;
  shouldShow: boolean;
}

const ApplicationTimer = ({expire_at, shouldShow}: Props) => {
  const [expireIn, setExpireIn] = React.useState(() => {
    return getTimeRemaining(expire_at);
  });
  const initial = useRef(getTimeRemaining(expire_at));

  useEffect(() => {
    if (initial.current) {
      const timer = setInterval(() => {
        const remaining = getTimeRemaining(expire_at);
        if (remaining) {
          setExpireIn(remaining);
        } else {
          clearInterval(timer);
          window.location.reload();
        }
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [expire_at, initial]);

  if (!expireIn || !shouldShow) {
    return null;
  }

  const times = [
    expireIn.days,
    expireIn.hours,
    expireIn.minutes,
    expireIn.seconds,
  ];

  return (
    <React.Fragment>
      <div
        className="d-flex align-items-center justify-content-between gap-2 flex-nowrap"
        style={{
          backgroundColor: 'red',
          padding: '10px',
          borderRadius: '5px',
          width: '270px',
        }}
      >
        <div className="text-nowrap" style={{fontWeight: 700, color: 'white'}}>
          Remaining Time :
        </div>
        <div className="timer d-flex align-items-center text-nowrap">
          {times.map((time, index) => {
            const value = time < 10 ? `0${time}` : time;
            const isLast = time === expireIn.seconds;
            const postfix = isLast ? '' : ' :';
            const key = value + index.toString();

            return (
              <div
                key={key}
                style={{fontWeight: 600, color: 'white'}}
                className="time"
              >
                {value + postfix}
              </div>
            );
          })}
        </div>
      </div>
      <div className="sep" />
    </React.Fragment>
  );
};

export default ApplicationTimer;
